import { useState } from 'react';
import { LocalizedText, useDialogAction } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { IconName, ActionToolbarButton } from '@optimus-web/core';
import { WithEnterpriseIds } from '../../../../types';
import { CREATE_RATE_STARTING_POINT } from '../../../../utilities/userFlowTestIds';
import { CreateRateContainer } from './CreateRateContainer';

export const CreateRateDialog = ({ enterpriseIds }: WithEnterpriseIds) => {
    const { states, handlers } = useDialogAction(async () => Promise.resolve());
    const [isDependentRate, setIsDependentRate] = useState(false);

    const areNoRowsSelected = enterpriseIds.length === 0;

    return (
        <>
            <ActionToolbarButton
                data-test-id={CREATE_RATE_STARTING_POINT}
                onClick={() => {
                    setIsDependentRate(false);
                    handlers.handleOpen();
                }}
                icon={IconName.Add}
                disabled={areNoRowsSelected}
            >
                <LocalizedText textKey={TextKey.CreateBaseRate} />
            </ActionToolbarButton>

            <ActionToolbarButton
                data-test-id={CREATE_RATE_STARTING_POINT}
                onClick={() => {
                    setIsDependentRate(true);
                    handlers.handleOpen();
                }}
                icon={IconName.Add}
                disabled={areNoRowsSelected}
            >
                <LocalizedText textKey={TextKey.CreateDependentRate} />
            </ActionToolbarButton>

            {states.isDialogOpened && (
                <CreateRateContainer
                    isOpened={states.isDialogOpened}
                    onConfirm={handlers.handleConfirm}
                    onCancel={handlers.handleCancel}
                    isDependentRate={isDependentRate}
                    enterpriseIds={enterpriseIds}
                />
            )}
        </>
    );
};
